<template>
  <div>
    <!-- Selettore Categorie (Tab) -->
    <div :class="'row menu-wrapper d-md-flex justify-content-md-center ' + (lang + '-menu')">
      <div
          v-for="(voice, index) in main"
          :key="'category-' + index"
          @click="setActiveMenu(voice)"
          :class="{
          'bounce': true,
          'single-col': true,
          'hvr-grow-rotate': true,
          'col-md-2': true,
          'col-xs-4': true,
          'active': voice.active,
          'voice-disabled': voice.disabled
        }"
      >
        <img :src="'/images/icons/' + voice.icon" />
        <!-- Titolo della categoria, ricavato dalle categories -->
        <span>{{ categories[voice.course][lang] }}</span>
      </div>
    </div>

<!--    <div v-if="noHeightLimit" class="wine-alert mt-5" role="alert" v-html="wineLabels[lang]"></div>-->

    <!-- Sezione Dettagli (Lista Piatti) -->
    <div class="menu-section mt-5">
      <!-- Titolo categoria -->
      <h2>{{ activeMenuTitle }}</h2>

      <!-- Filtri -->
      <div class="filters" v-if="['red_wine', 'white_wine', 'rose_wine', 'drinks_bitter', 'drinks_hot', 'drinks_soft', 'drinks_beer', 'drinks_aperitif'].indexOf(activeMenu.course) < 0">
        <label v-if="['desserts'].indexOf(activeMenu.course) < 0">
          <input
              type="checkbox"
              v-model="filters.sansPorc"
              :indeterminate="filters.sansPorc === null"
          />
          <img src="/images/no_pork.png" width="20px" />
          {{ i18nFilters.no_pork[lang] }}
        </label>
        <label>
          <input
              type="checkbox"
              v-model="filters.vegan"
              :indeterminate="filters.vegan === null"
          />
          <img src="/images/vegan.svg" width="20px" />
          {{ i18nFilters.vegan[lang] }}
        </label>
        <label>
          <input
              type="checkbox"
              v-model="filters.vegetarien"
              :indeterminate="filters.vegetarien === null"
          />
          <img src="/images/vegetarian.svg" width="20px" />
          {{ i18nFilters.vegetarian[lang] }}
        </label>
      </div>

      <div class="row">
        <div class="col-xs-12 col-md-12">
          <!-- Filtra per ingredienti -->
          <p class="small-description" v-if="allPiattiIngredients.length > 0">
            {{ i18nStrings.filter_by_ingredients[lang] }}
          </p>
          <ul class="menu-ingredients" v-if="allPiattiIngredients.length > 0">
            <li
                v-for="(ingredient, index) in allPiattiIngredients"
                :key="'ingredient-' + index"
            >
              <n-button
                  v-if="activeMenu.ingredientsFilter.indexOf(ingredient) < 0"
                  size="sm"
                  type="primary"
                  @click="addIngredient(ingredient)"
              >
                <i class="fa fa-plus mr-2"></i> {{ ingredient }}
              </n-button>
            </li>
          </ul>

          <!-- Ingredienti selezionati -->
          <p class="small-description" v-if="activeMenu.ingredientsFilter.length > 0">
            {{ i18nStrings.selected_ingredients[lang] }}
          </p>
          <ul class="menu-ingredients" v-if="activeMenu.ingredientsFilter.length > 0">
            <li
                v-for="(ingredient, index) in activeMenu.ingredientsFilter"
                :key="'ingredient-selected-' + index"
            >
              <n-button size="sm" type="success" @click="removeIngredient(ingredient)">
                <i class="fa fa-times mr-2"></i> {{ ingredient }}
              </n-button>
            </li>
          </ul>

          <!-- Lista piatti -->
          <ul :class="{'menu-list': true, 'no-height-limits': noHeightLimit}">
            <!-- Intestazione visibile solo per le pizze -->
            <li
                v-if="activeMenu.course === 'pizza'"
                class="list-header d-flex justify-content-between"
                style="font-weight: bold;"
            >
              <div class="info"></div>
              <div
                  class="prices d-flex justify-content-between prices-heading"
                  style="width: 160px;"
              >
                <!-- Ronde / Demi-Mètre -->
                <span>{{ pizzaColumns.round[lang] }}</span>
                <span>{{ pizzaColumns.half_meter[lang] }}</span>
              </div>
            </li>

            <!-- Esempio testo aggiuntivo per la pasta -->
            <li v-if="activeMenu.course === 'pasta'">
              <div class="font-weight-bold text-left text-sm-center w-100">
                {{ i18nStrings.supplements[lang] }}:
                <div class="d-block d-sm-none"/>
                Gnocchi +4.00€
                <span class="d-none d-sm-inline">&nbsp;/&nbsp;</span>
                <div class="d-block d-sm-none"/>
                Tagliatelle +2.00€
              </div>
            </li>

            <!-- Iterazione sui piatti -->
            <li v-for="piatto in getPiatti" :key="piatto.name">
              <div class="info">
                <!-- Nome del piatto: se esiste la traduzione, la utilizza -->
                <span class="name">{{ getDishName(piatto) }}</span>
                <!-- Descrizione tradotta, se disponibile -->
                <span class="description" v-if="(piatto.description || (piatto.i18n_description && piatto.i18n_description[lang]))">
                  {{ getDishDescription(piatto) }}
                </span>

                <!-- Ingredienti tradotti -->
                <div class="ingredients" v-if="(piatto.ingredients && piatto.ingredients.length) || (piatto.i18n_ingredients && piatto.i18n_ingredients[lang] && piatto.i18n_ingredients[lang].length)">
                  <template v-for="(ingredient, index) in getDishIngredients(piatto)">
                    <span
                        :key="'ingredient-sm-' + index"
                        class="d-none btn btn-primary btn-sm d-sm-inline-block ingredient"
                    >
                      {{ ingredient.trim() }}
                    </span>
                    <span
                        :key="'ingredient-xs-' + index"
                        class="d-inline-block d-sm-none ingredient-xs"
                    >
                      {{ ingredient.trim() }}<template v-if="getDishIngredients(piatto).length -1 > parseInt(index)">,&nbsp;</template>
                    </span>
                  </template>
                </div>

                <!-- Allergeni e Regimi alimentari -->
                <div class="allergens">
                  <div v-if="piatto.has_pork" class="d-inline-block">
                    <img src="/images/pork.png" class="allergen" />
                  </div>
                  <div v-if="piatto.is_vegetarian" class="d-inline-block">
                    <img src="/images/vegetarian.svg" class="allergen" />
                  </div>
                  <div v-if="piatto.is_vegan" class="d-inline-block">
                    <img src="/images/vegan.svg" class="allergen" />
                  </div>
                  <div v-if="piatto.allergens && piatto.allergens.length > 0" class="d-inline-block">
                    <img
                        v-for="(allergen, index) in piatto.allergens"
                        :key="'allergen-' + index"
                        :src="`/images/allergens-compressed/${allergen}.png`"
                        class="allergen"
                    />
                  </div>
                </div>
              </div>

              <!-- Prezzi -->
              <div
                  class="prices"
                  v-if="activeMenu.course === 'pizza'"
                  style="display: flex; justify-content: space-between; width: 160px;"
              >
                <span class="price">
                  {{ piatto.price ? piatto.price.toFixed(2) : '-' }}
                </span>
                <span class="price">
                  {{ piatto.price_half_meter ? piatto.price_half_meter.toFixed(2) : '-' }}
                </span>
              </div>
              <div class="prices" v-else>
                <span class="price">
                  {{ piatto.price ? piatto.price.toFixed(2) : '-' }}
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Legenda Allergeni -->
    <div class="allergens-legend mt-5">
      <h3>{{ labels.allergens[lang] }}</h3>
      <div
          v-for="(allergenKey, index) in Object.keys(allergenList)"
          :key="'legend-allergen-' + index"
          class="d-inline-flex pr-2 align-items-center mb-2"
      >
        <img
            :src="`/images/allergens-compressed/${allergenList[allergenKey].image}`"
            :alt="allergenList[allergenKey][lang]"
            class="allergen me-2"
        />
        <span>{{ allergenList[allergenKey][lang] }}</span>
      </div>

      <h3 class="mt-2">{{ labels.dietary_requirements[lang] }}</h3>
      <div
          v-for="(dietKey, i) in Object.keys(dietaryLabels)"
          :key="'diet-label-' + i"
          class="d-inline-flex pr-2 align-items-center mb-2"
      >
        <img
            :src="`/images/${dietaryLabels[dietKey].image}`"
            :alt="dietaryLabels[dietKey][lang]"
            class="allergen me-2"
        />
        <span>{{ dietaryLabels[dietKey][lang] }}</span>
      </div>
    </div>
    <!-- Fine Legenda Allergeni -->
  </div>
</template>

<script>
import NButton from "./Button";
import LanguageSelector from "./Inputs/LanguageSelector.vue";

export default {
  name: "OSMMenu",
  components: { LanguageSelector, NButton },

  props: {
    // Lingua corrente (default: 'nl' in questo esempio)
    lang: {
      type: String,
      default: 'fr'
    },
    // Se true, disabilita il limite max-height della lista
    noHeightLimit: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      // Stesso dizionario "categories" del Blade
      categories: {
        appetisers: {
          fr: 'Entrées',
          en: 'Appetisers',
          nl: 'Starters',
          it: 'Antipasti',
          de: 'Vorspeisen'
        },
        pizza: {
          fr: 'Pizza',
          en: 'Pizza',
          nl: 'Pizza',
          it: 'Pizza',
          de: 'Pizza'
        },
        pasta: {
          fr: 'Pâtes',
          en: 'Pasta',
          nl: 'Pasta',
          it: 'Pasta',
          de: 'Pasta'
        },
        desserts: {
          fr: 'Desserts',
          en: 'Desserts',
          nl: 'Desserts',
          it: 'Dolci',
          de: 'Desserts'
        },
        drinks_aperitif: {
          fr: 'Apéritifs',
          it: 'Aperitivi',
          nl: 'Aperitieven',
          en: 'Aperitifs',
          de: 'Aperitifs'
        },
        red_wine: {
          fr: "Vins rouges",
          en: "Red wines",
          nl: "Rode wijnen",
          it: "Vini rossi",
          de: "Rotweine"
        },
        white_wine: {
          fr: "Vins blancs",
          en: "White wines",
          nl: "Witte wijnen",
          it: "Vini bianchi",
          de: "Weißweine"
        },
        rose_wine: {
          fr: "Vins rosés",
          en: "Rosé wines",
          nl: "Roséwijnen",
          it: "Vini rosati",
          de: "Roséweine"
        },
        drinks_beer: {
          fr: 'Bières',
          it: 'Birre',
          nl: 'Bieren',
          en: 'Beers',
          de: 'Biere'
        },
        drinks_soft: {
          fr: 'Softs',
          it: 'Bibite',
          nl: 'Fris',
          en: 'Softs',
          de: 'Softs'
        },
        drinks_hot: {
          fr: "Thé/Café",
          it: "Tè/Caffè",
          nl: "Thee/Koffie",
          en: "Tea/Coffee",
          de: "Tee/Kaffee"
        },
        drinks_bitter: {
          fr: 'Digestif',
          it: 'Digestivi',
          nl: 'Digestief',
          en: 'Digestif',
          de: 'Digestif'
        }
      },

      // Stesse label generiche del Blade
      labels: {
        price: {
          fr: 'Prix',
          it: 'Prezzo',
          nl: 'Prijs',
          en: 'Price',
          de: 'Preis'
        },
        price_half_meter: {
          fr: 'Prix 1/2 mètre',
          it: 'Prezzo 1/2 metro',
          nl: 'Prijs 1/2 meter',
          en: 'Price 1/2 meter',
          de: 'Preis 1/2 Meter'
        },
        menu: {
          fr: 'Menu',
          it: 'Menù',
          nl: 'Menu',
          en: 'Menu',
          de: 'Menü'
        },
        language: {
          fr: 'Français',
          it: 'Italiano',
          nl: 'Nederlands',
          en: 'English',
          de: 'Deutsch'
        },
        allergens: {
          fr: 'Allergènes',
          it: 'Allergeni',
          nl: 'Allergenen',
          en: 'Allergens',
          de: 'Allergene'
        },
        dietary_requirements: {
          fr: 'Régimes alimentaires',
          it: 'Regimi alimentari',
          nl: 'Dieetvereisten',
          en: 'Dietary requirements',
          de: 'Ernährungsanforderungen'
        }
      },

      // Traduzioni di alcune stringhe ricorrenti nel template
      i18nStrings: {
        filter_by_ingredients: {
          fr: 'Filtrer par ingrédients',
          en: 'Filter by ingredients',
          it: 'Filtrare per ingredienti',
          nl: 'Filter op ingrediënten',
          de: 'Nach Zutaten filtern'
        },
        selected_ingredients: {
          fr: 'Ingrédients sélectionnés',
          en: 'Selected ingredients',
          it: 'Ingredienti selezionati',
          nl: 'Geselecteerde ingrediënten',
          de: 'Ausgewählte Zutaten'
        },
        supplements: {
          fr: 'Suppléments',
          en: 'Supplements',
          it: 'Supplementi',
          nl: 'Supplementen',
          de: 'Zusätze'
        }
      },

      // Traduzioni per i filtri "Sans porc", "Végan", "Végétarien"
      i18nFilters: {
        no_pork: {
          fr: 'Sans porc',
          en: 'No pork',
          it: 'Senza maiale',
          nl: 'Zonder varkensvlees',
          de: 'Ohne Schweinefleisch'
        },
        vegan: {
          fr: 'Végan',
          en: 'Vegan',
          it: 'Vegano',
          nl: 'Veganistisch',
          de: 'Vegan'
        },
        vegetarian: {
          fr: 'Végétarien',
          en: 'Vegetarian',
          it: 'Vegetariano',
          nl: 'Vegetarisch',
          de: 'Vegetarisch'
        }
      },

      // Colonne pizza: Ronde / Demi-Mètre (come da template)
      pizzaColumns: {
        round: {
          fr: 'Ronde',
          en: 'Round',
          it: 'Rotonda',
          nl: 'Rond',
          de: 'Rund'
        },
        half_meter: {
          fr: 'Demi-Mètre',
          en: 'Half-meter',
          it: 'Mezzo metro',
          nl: 'Halve meter',
          de: 'Halber Meter'
        }
      },

      // Stessa struttura "allergenList" (oggetto con chiave -> {image, fr, it, nl, en, de})
      allergenList: {
        almond: {
          image: "almond.png",
          fr: "Amande",
          it: "Mandorla",
          nl: "Amandel",
          en: "Almond",
          de: "Mandel"
        },
        avocado: {
          image: "avocado.png",
          fr: "Avocat",
          it: "Avocado",
          nl: "Avocado",
          en: "Avocado",
          de: "Avocado"
        },
        blueberries: {
          image: "blueberries.png",
          fr: "Myrtilles",
          it: "Mirtilli",
          nl: "Blauwe bessen",
          en: "Blueberries",
          de: "Heidelbeeren"
        },
        celery: {
          image: "celery.png",
          fr: "Céleri",
          it: "Sedano",
          nl: "Selderij",
          en: "Celery",
          de: "Sellerie"
        },
        color: {
          image: "color.png",
          fr: "Colorant",
          it: "Colorante",
          nl: "Kleurstof",
          en: "Colorant",
          de: "Farbstoff"
        },
        corn: {
          image: "corn.png",
          fr: "Maïs",
          it: "Mais",
          nl: "Maïs",
          en: "Corn",
          de: "Mais"
        },
        crustaceans: {
          image: "crustaceans.png",
          fr: "Crustacés",
          it: "Crostacei",
          nl: "Schaaldieren",
          en: "Crustaceans",
          de: "Krustentiere"
        },
        eggs: {
          image: "eggs.png",
          fr: "Œufs",
          it: "Uova",
          nl: "Eieren",
          en: "Eggs",
          de: "Eier"
        },
        fish: {
          image: "fish.png",
          fr: "Poisson",
          it: "Pesce",
          nl: "Vis",
          en: "Fish",
          de: "Fisch"
        },
        gluten: {
          image: "gluten.png",
          fr: "Gluten",
          it: "Glutine",
          nl: "Gluten",
          en: "Gluten",
          de: "Gluten"
        },
        kiwi: {
          image: "kiwi.png",
          fr: "Kiwi",
          it: "Kiwi",
          nl: "Kiwi",
          en: "Kiwi",
          de: "Kiwi"
        },
        lemon: {
          image: "lemon.png",
          fr: "Citron",
          it: "Limone",
          nl: "Citroen",
          en: "Lemon",
          de: "Zitrone"
        },
        lupin: {
          image: "lupin.png",
          fr: "Lupin",
          it: "Lupino",
          nl: "Lupine",
          en: "Lupin",
          de: "Lupine"
        },
        meat: {
          image: "meat.png",
          fr: "Viande",
          it: "Carne",
          nl: "Vlees",
          en: "Meat",
          de: "Fleisch"
        },
        milk: {
          image: "milk.png",
          fr: "Lait",
          it: "Latte",
          nl: "Melk",
          en: "Milk",
          de: "Milch"
        },
        molluscs: {
          image: "molluscs.png",
          fr: "Mollusques",
          it: "Molluschi",
          nl: "Weekdieren",
          en: "Molluscs",
          de: "Weichtiere"
        },
        mushroom: {
          image: "mushroom.png",
          fr: "Champignon",
          it: "Fungo",
          nl: "Paddenstoel",
          en: "Mushroom",
          de: "Pilz"
        },
        mustard: {
          image: "mustard.png",
          fr: "Moutarde",
          it: "Senape",
          nl: "Mosterd",
          en: "Mustard",
          de: "Senf"
        },
        nuts: {
          image: "nuts.png",
          fr: "Fruits à coque",
          it: "Frutta a guscio",
          nl: "Noten",
          en: "Nuts",
          de: "Nüsse"
        },
        peach: {
          image: "peach.png",
          fr: "Pêche",
          it: "Pesca",
          nl: "Perzik",
          en: "Peach",
          de: "Pfirsich"
        },
        peanut: {
          image: "peanut.png",
          fr: "Cacahuète",
          it: "Arachide",
          nl: "Pinda",
          en: "Peanut",
          de: "Erdnuss"
        },
        salmon: {
          image: "salmon.png",
          fr: "Saumon",
          it: "Salmone",
          nl: "Zalm",
          en: "Salmon",
          de: "Lachs"
        },
        sesame: {
          image: "sesame.png",
          fr: "Sésame",
          it: "Sesamo",
          nl: "Sesam",
          en: "Sesame",
          de: "Sesam"
        },
        soy: {
          image: "soy.png",
          fr: "Soja",
          it: "Soia",
          nl: "Soja",
          en: "Soy",
          de: "Soja"
        },
        strawberry: {
          image: "strawberry.png",
          fr: "Fraise",
          it: "Fragola",
          nl: "Aardbei",
          en: "Strawberry",
          de: "Erdbeere"
        },
        sugar: {
          image: "sugar.png",
          fr: "Sucre",
          it: "Zucchero",
          nl: "Suiker",
          en: "Sugar",
          de: "Zucker"
        },
        sulphite: {
          image: "sulphite.png",
          fr: "Sulfites",
          it: "Solfiti",
          nl: "Sulfieten",
          en: "Sulphites",
          de: "Sulfite"
        },
        "trans-fat": {
          image: "trans-fat.png",
          fr: "Acides gras insaturés",
          it: "Grassi trans",
          nl: "Transvetten",
          en: "Trans fats",
          de: "Transfette"
        },
        yogurt: {
          image: "yogurt.png",
          fr: "Yaourt",
          it: "Yogurt",
          nl: "Yoghurt",
          en: "Yogurt",
          de: "Joghurt"
        }
      },

      // Stessa struttura "dietaryLabels"
      dietaryLabels: {
        vegan: {
          image: 'vegan.svg',
          fr: 'Végétalien',
          it: 'Vegano',
          nl: 'Veganistisch',
          en: 'Vegan',
          de: 'Vegan'
        },
        vegetarian: {
          image: 'vegetarian.svg',
          fr: 'Végétarien',
          it: 'Vegetariano',
          nl: 'Vegetarisch',
          en: 'Vegetarian',
          de: 'Vegetarisch'
        },
        pork: {
          image: 'pork.png',
          fr: 'Contient du porc',
          it: 'Contiene maiale',
          nl: 'Bevat varkensvlees',
          en: 'Contains pork',
          de: 'Enthält Schweinefleisch'
        }
      },

      wineLabels: {
        it: "<h4 class='my-0'><span>🍷</span> Scopri la nostra selezione di vini! <span>🍷</span></h4>Chiedi al personale la carta dei vini.",
        en: "<h4 class='my-0'><span>🍷</span> Discover our selection of wines! <span>🍷</span></h4> Ask the staff for the wine list.",
        fr: "<h4 class='my-0'><span>🍷</span> Découvrez notre sélection de vins ! <span>🍷</span></h4> Demandez la carte des vins au personnel.",
        nl: "<h4 class='my-0'><span>🍷</span> Ontdek onze selectie wijnen! <span>🍷</span></h4> Vraag het personeel om de wijnkaart.",
        de: "<h4 class='my-0'><span>🍷</span> Entdecken Sie unsere Weinauswahl! <span>🍷</span></h4> Fragen Sie das Personal nach der Weinkarte."
      },

      // Filtri booleani
      filters: {
        sansPorc: null,
        vegan: null,
        vegetarien: null
      },

      // Categorie principali (tab); "course" si collega a state.all[course] in Vuex
      main: [
        {
          course: 'appetisers',
          icon: '012-board.svg',
          active: false,
          ingredientsFilter: [],
          disabled: false
        },
        {
          course: 'pizza',
          icon: '003-pizza-1.svg',
          active: true,
          ingredientsFilter: [],
          disabled: false
        },
        {
          course: 'pasta',
          icon: '013-pasta.svg',
          active: false,
          ingredientsFilter: [],
          disabled: false
        },
        {
          course: 'desserts',
          icon: '006-cupcake.svg',
          active: false,
          ingredientsFilter: [],
          disabled: false
        },
        {
          course: 'drinks_soft',
          icon: '007-can.svg',
          active: false,
          ingredientsFilter: [],
          disabled: false
        },
        {
          course: 'drinks_aperitif',
          icon: '001-juice.svg',
          active: false,
          ingredientsFilter: [],
          disabled: false
        },
        {
          course: 'drinks_beer',
          icon: '011-beer.svg',
          active: false,
          ingredientsFilter: [],
          disabled: false
        },
        {
          course: 'drinks_bitter',
          icon: 'digestives.svg',
          active: false,
          ingredientsFilter: [],
          disabled: false
        },
        {
          course: 'red_wine',
          icon: 'wine_red.svg',
          active: false,
          ingredientsFilter: [],
          disabled: false
        },
        {
          course: 'white_wine',
          icon: 'wine_white.svg',
          active: false,
          ingredientsFilter: [],
          disabled: false
        },
        {
          course: 'rose_wine',
          icon: 'wine_rose.svg',
          active: false,
          ingredientsFilter: [],
          disabled: false
        },
        {
          course: 'drinks_hot',
          icon: 'coffee.png',
          active: false,
          ingredientsFilter: [],
          disabled: false
        }
      ]
    }
  },

  computed: {
    /**
     * Restituisce il tab attivo (uno solo)
     */
    activeMenu() {
      return this.main.find((m) => m.active);
    },

    /**
     * Restituisce il titolo localizzato della categoria attiva
     */
    activeMenuTitle() {
      if (!this.activeMenu) return '';
      return this.categories[this.activeMenu.course][this.lang];
    },

    /**
     * Ritorna l’elenco dei piatti (della categoria attiva) filtrato per ingredienti e filtri booleani.
     * Ora il getter riceve anche la lingua corrente.
     */
    getPiatti() {
      return this.$store.getters["menu/filterByIngredients"](
          this.activeMenu.course,
          this.activeMenu.ingredientsFilter,
          this.filters,
          this.lang
      );
    },

    /**
     * Lista di tutti gli ingredienti presenti nei piatti filtrati (tradotti se possibile)
     */
    allPiattiIngredients() {
      return this.$store.getters["menu/ingredients"](this.getPiatti, this.lang);
    }
  },

  methods: {
    /**
     * Cambia la categoria attiva
     */
    setActiveMenu(voice) {
      if (!voice.disabled) {
        this.main.forEach((m) => {
          m.active = (m.course === voice.course);
        });
      }
    },
    /**
     * Aggiunge un ingrediente ai filtri della categoria attiva
     */
    addIngredient(ingredient) {
      this.activeMenu.ingredientsFilter.push(ingredient);
    },
    /**
     * Rimuove un ingrediente dai filtri della categoria attiva
     */
    removeIngredient(ingredient) {
      const index = this.activeMenu.ingredientsFilter.indexOf(ingredient);
      if (index >= 0) {
        this.activeMenu.ingredientsFilter.splice(index, 1);
      }
    },
    /**
     * Ritorna il nome del piatto, utilizzando la traduzione se disponibile (e se la lingua non è il default "fr")
     */
    getDishName(dish) {

      if ( ['pizza', 'pasta'].indexOf(this.activeMenu.course) >= 0 ){
        return dish.name;
      }

      return dish.i18n_name && dish.i18n_name[this.lang] ? dish.i18n_name[this.lang] : dish.name;
      /*if (this.lang !== 'fr' && dish.i18n_name && dish.i18n_name[this.lang]) {
        return dish.i18n_name[this.lang];
      }
      return dish.name;*/
    },
    /**
     * Ritorna la descrizione del piatto, utilizzando la traduzione se disponibile
     */
    getDishDescription(dish) {
      if (this.lang !== 'fr' && dish.i18n_description && dish.i18n_description[this.lang]) {
        return dish.i18n_description[this.lang];
      }
      return dish.description;
    },
    /**
     * Ritorna l’elenco degli ingredienti del piatto, utilizzando la traduzione se disponibile
     */
    getDishIngredients(dish) {
      console.log('getDishIngredients', dish)
      if (this.lang !== 'fr' && dish.i18n_ingredients && dish.i18n_ingredients[this.lang] && dish.i18n_ingredients[this.lang].length) {
        return dish.i18n_ingredients[this.lang];
      }
      return dish.ingredients || [];
    }
  },

  async created() {
    await this.$store.dispatch("menu/fetchMenu");
  }
};
</script>

<style lang="scss">
@import url("~hover.css/css/hover-min.css");

@mixin animation-keyframes {
  $animation-number: 0 !default !global;
  $animation-number: $animation-number + 1 !global;
  $name: unquote("animation-#{$animation-number}");
  animation-name: $name;
  @at-root {
    @keyframes #{$name} {
      @content;
    }
  }
}

@mixin osm-scrollbar {
  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  &::-webkit-scrollbar-track {
    background: #ddd;
  }

  &::-webkit-scrollbar-thumb {
    background: #008233;
  }
}

.page-header-image {
  @media screen and (max-width: 768px) {
    background-position: center left !important;
  }
}

ul.menu-list {
  list-style-type: none;
  padding: 0 15px;
  margin: 0;
  text-align: left;
  display: block;
  width: 100%;
  max-height: 50vh;
  overflow: auto;
  @include osm-scrollbar;

  &.no-height-limits{
    max-height: unset;
    padding: 0;
  }

  li {
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
    padding-bottom: 15px;

    &:not(:last-child) {
      border-bottom: 2px dashed #ddd;
    }

    span {
      display: block;

      &.name {
        font-size: 1.8em;

        @media screen and (max-width: 600px){
          font-size: 1.4em;
        }
      }
    }

    .prices {
      display: flex;
      align-self: center;
      justify-content: space-between;
      min-width: 70px;

      @media screen and (max-width: 600px){
        width: 225px !important;
        justify-content: flex-end !important;
        .price {
          &:first-child {
            padding-right: 5px;
          }
        }
      }

      .price {
        text-align: right;
        margin-left: 0;

        &.hidden-price {
          opacity: 0;
        }

        &:not(.no-euro)::after {
          content: "€";
          font-size: 11px;
        }
      }
    }
  }
}

.prices-heading{
  @media screen and (max-width: 600px){
    width: 225px !important;
    justify-content: flex-end !important;
    >span {
      &:first-child {
        padding-right: 5px;
      }
    }
  }
}

ul.menu-ingredients {
  list-style-type: none;
  padding: 0;
  text-align: left;
  overflow-x: auto;
  display: flex;
  @include osm-scrollbar;

  li {
    display: inline-block;

    button {
      text-transform: capitalize;
    }
  }
}

.description {
  color: #000 !important;
  font-weight: 400 !important;
}

.menu-section {
  .small-description {
    margin: 0;
    color: #888;
    font-size: 11px;
    text-align: left;
    font-weight: bold;
  }
}

.menu-wrapper {
  @include osm-scrollbar;
  @media screen and (max-width: 1000px) {
    display: block !important;
    margin: 0 !important;
    overflow-x: auto;
    overflow-y: hidden;
        padding: 30px 15px;

    .single-col {
      width: 75px;
      margin: 30px 15px;
    }
  }

  @media screen and (max-width: 768px) {
    padding: 15px 15px;
  }

  .single-col {
    cursor: pointer;
    text-align: center;
    max-height: 126px;

    @media screen and (max-width: 768px) {
      padding: 0;
      margin: 10px 5px;
    }

    @media screen and (max-width: 500px){
      height: 100px;

    }

    &:before {
      content: "";
      position: absolute;
      width: 120%;
      height: 120%;
      border-radius: 50%;
      background: #008233;
      top: 50%;
      margin-top: -60%;
      left: 50%;
      margin-left: -60%;

      @media screen and (max-width: 1000px) {
        width: 160px;
        height: 160px;
        margin-top: -80px;
        margin-left: -80px;
      }

      @media screen and (max-width: 768px) {
        width: 95px;
        height: 95px;
        margin-top: -60.5px;
        margin-left: -47.5px;
      }

      z-index: 10;
      transform: scale(0);
    }

    &.active {
      &:before {
        background: #a82c35;
      }
    }

    &.active,
    &:hover {
      &:before {
        animation: 0.2s linear;
        animation-fill-mode: forwards;
        @include animation-keyframes {
          0% {
            opacity: 0;
            transform: scale(0.3);
          }
          50% {
            transform: scale(0.6);
          }
          70% {
            transform: scale(0.9);
          }
          100% {
            transform: scale(1);
          }
        }
      }

      span {
        animation: 0.2s linear;
        animation-fill-mode: forwards;
        line-height: 12px;
        @include animation-keyframes {
          0% {
          }
          50% {
          }
          70% {
          }
          100% {
            color: #fff;
          }
        }
      }
    }

    span,
    img {
      position: relative;
      z-index: 20;
    }

    span {
      display: block;
      margin-top: 15px;
    }

    img {
      max-width: 90px;
      margin: 0 auto;
      display: block;

      @media screen and (max-width: 768px) {
        max-width: 40px;
      }
    }
  }
}

.single-col.voice-disabled {
  opacity: 0.4;
}

.allergen {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}

.ingredient {
  text-transform: capitalize;
}

.allergens-legend {
  h3 {
    font-size: 1.3rem;
    margin-bottom: 0.5rem;
  }

  ul {
    list-style-type: none;
    padding: 0;

    li {
      display: inline-block;
      img.allergen {
        width: 24px;
        height: 24px;
      }
    }
  }
}

.ingredients .btn {
  margin: 2px 2px;
  font-size: 12px !important;
  padding: 2px 4px !important;
}

.ingredients .ingredient-xs{
  text-transform: capitalize;
}
.allergens {
  margin-top: 5px;
}

.filters {
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  label {
    margin-right: 1rem;
    display: flex;
    align-items: center;
    gap: 5px;
  }

  input[type="checkbox"] {
    width: 18px;
    height: 18px;
    accent-color: #A9282F;
  }
}

.menu-wrapper .single-col:hover, .menu-wrapper .single-col.active {
  z-index: 11;
  position: relative;
}

.wine-alert{
  padding: 15px;
  text-align: center;
  border: 2px solid #a82c35;
  border-radius: 8px;
  background: #fbfbfb;

  h4{
    font-weight: bolder;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;

  }
}
</style>